// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6fc4ef3a","513":"0fba9a45","787":"45b14bc1"}[chunkId] + ".chunk.js";
};